import { Card, CardContent } from '@mui/material';
import React from 'react';
import { headingFontBold } from '../../../../Theme';
import { useTranslation } from 'react-i18next';

export default ({ translationKey }: { translationKey: string }) => {
    const { t } = useTranslation('translations', { keyPrefix: 'sidepanel' });

    return (
        <Card sx={{ ...headingFontBold, fontSize: 14 }} variant='outlined'>
            <CardContent sx={{ p: 1.5 }}>{t(translationKey)}</CardContent>
        </Card>
    );
};
